export default {
    newDesign: true,
    parameters: {
        landing_id: "BRLPquizDsh",
        segment: 42,
    },
    title:
        "Responda a estas perguntas e ganhe uma aula experimental para seu filho/a! | Kodland",
    downtimeUrl: "https://www.kodland.org/pt",
    startPage: {
        title:
            "Vamos criar um plano de aprendizagem personalizado para o seu filho",
        subtitle:
            "Responda a algumas perguntas rápidas, nós vamos indicar o melhor curso e mostrar quais habilidades o seu filho vai desenvolver",
        image: {
            url: "/welcome/brazil_scoring_google_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/brazil_scoring_google_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Começar o quiz",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Obrigado por confiar em nossa plataforma educacional!",
        subtitle:
            "Infelizmente, tablets ou telefones não são adequados para assistir às nossas aulas. Ficaremos felizes em vê-lo em nossas aulas na próxima vez!",
    },
    quizRotateBySteps: {
        1: {
            title: "Quantos anos tem o seu filho?",
            type: "age",
            button: "",
        },
        2: {
            question: "Em que o seu filho mais se interessa?",
            answers: [
                "Criar seus próprios jogos 🎮",
                "Construir no Minecraft 🧱",
                "Aprender a programar 💻",
                "Resolver desafios de lógica 🧩"
            ],
        },
        3: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/br_father_and_son_with_laptop.png",
            subtitle:
                "Usaremos suas respostas para criar um caminho de aprendizado personalizado, para seu filho aprender com motivação e diversão",
            button: "Continuar",
        },
        4: {
            question: "Como seu filho aprende ou lembra melhor das coisas novas?",
            answers: [
                "Vendo (aprende de forma visual) 👁️",
                "Fazendo (aprende praticando) 👐",
                "Ouvindo (aprende auditivamente) 🎧",
                "Através de repetição e prática ✏️"
            ],
        },
        5: {
            question: "Que tipo de atividades seu filho mais gosta?",
            answers: [
                "Descobrir como as coisas funcionam 🧠",
                "Criar ou construir algo novo 🎨",
                "Jogar e modificar jogos 🎮",
                "Trabalhar com amigos em projetos 🤝"
            ]
        },
        6: {
            question: "Quão motivada(o) está sua criança para experimentar coisas novas?",
            answers: [
                "Muito motivada(o)💪",
                "Precisa de incentivo 🤔",
                "Pouco motivada(o) 😕"
            ]
        },
        7: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/br_reclame.png",
            title: "Confiado por mais de 200.000 pais e alunos",
            subtitle:
                "Os pais adoram como nossos professores tornam a programação divertida e fácil de entender.",
            button: "Continuar",
        },
        8: {
            question: "Você gostaria que seu filho(a) explorasse habilidades do futuro, como programação ou inteligência artificial?",
            answers: [
                "Sim ✨",
                "Talvez mais tarde 🤔",
                "Não ❌"
            ]
        },
        9: {
            question: "Seu filho tem acesso a um laptop ou computador para estudar?",
            answers: [
                "Sim, ele tem o próprio dispositivo ✅",
                "Sim, mas ele compartilha com outras pessoas 👨‍👩‍👧",
                {
                    answer: "Não, ele não tem acesso regular 🚫",
                    stopAnswer: true,
                },
            ]
        },
        10: {
            question: "O que faz seu filho se sentir orgulhoso ou realizado?",
            answers: [
                "Concluir um desafio 🏆",
                "Aprender algo novo 💡",
                "Criar algo que outras pessoas possam jogar 🎮",
                "Receber feedback positivo 💬"
            ]
        },
        11: {
            typeInfo: "loaderScreen",
            sliderImages: [
                "/welcome/br_longquiz_dev_2_r1.png",
                "/welcome/br_longquiz_dev_2_r2.png",
                "/welcome/br_longquiz_dev_2_r3.png",
            ],
            sliderImagesMobile: [
                "/welcome/br_longquiz_dev_2_r1_mob.png",
                "/welcome/br_longquiz_dev_2_r2_mob.png",
                "/welcome/br_longquiz_dev_2_r3_mob.png",
            ],
            textLoader: "Criando o plano de aprendizado personalizado do seu filho…",
            titleLoader: 'Estamos analisando suas respostas para encontrar o melhor curso e o professor ideal',
            subtitleLoader: "⭐ 4,8 / 5 — baseado em mais de 50.000 avaliações",
        },
        12: {
            dynamicTypeInfo: [
                {
                    condition: [
                        {
                            step: 2,
                            answer: "Criar seus próprios jogos 🎮",
                        }
                    ],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/br_girl_with_laptop.png",
                        title: "🎮 Recomendado: Desenvolvedor de Jogos",
                        subtitle:
                            "Seu filho vai criar e programar seus próprios jogos 3D, desenvolvendo criatividade, lógica e habilidades de resolução de problemas.</br>Perfeito para mentes curiosas que adoram criar mundos do zero.",
                        button: "Agendar agora",
                    },
                },
                {
                    condition: [
                        {
                            step: 2,
                            answer: "Construir no Minecraft 🧱",
                        }
                    ],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/br_girl_with_laptop.png",
                        title: "🧱 Recomendado: Curso de Programação no Minecraft",
                        subtitle:
                            "As crianças aprendem programação dentro do próprio Minecraft, construindo lógica, estrutura e criatividade passo a passo.</br>Um ambiente divertido e familiar para aprender habilidades reais de programação.",
                        button: "Agendar agora",
                    },
                },
                {
                    condition: [
                        {
                            step: 2,
                            answer: "Aprender a programar 💻",
                        }
                    ],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/br_girl_with_laptop.png",
                        title: "💻 Recomendado: Python para Iniciantes",
                        subtitle:
                            "Um ótimo começo na programação para jovens curiosos e com raciocínio lógico.",
                        button: "Agendar agora",
                    },
                },
                {
                    default: true,
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/br_girl_with_laptop.png",
                        title: "🕹 Recomendado: Desenvolvedor de Jogos no Roblox",
                        subtitle:
                            "Seu filho vai criar seus próprios jogos no Roblox Studio, aprender lógica de programação e compartilhar suas criações com amigos.",
                        button: "Agendar agora",
                    },
                },
            ],
        },
        13: {
            typeInfo: "congrats",
            title: "🎉 Tudo pronto para a aula gratuita do seu filho!",
            subtitle:
                "No próximo passo, preencha seus dados e escolha o melhor dia e horário para ele aproveitar a aula.",
            button: "📅 Agendar aula gratuita",
        },
        14: {
            title: "Agende uma aula gratuita",
            type: "one-page-contacts",
            subtitle: "",
            button: "Quase lá! 🔥",
        },
        15: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        16: {
            title: "Obrigado 🎉 Faltam apenas alguns passos para concluir o cadastro",
            typeInfo: "pc-laptop",
            subtitle:
                "Por favor, observe que você precisará de um PC ou laptop funcional para a aula e que deve acompanhar seu filho durante toda a aula.",
            button: "O que mais?",
        },
        17: {
            title: "Verifique seu e-mail e WhatsApp antes da aula experimental 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Enviaremos um lembrete 24 horas antes da aula e 2 horas antes da aula pediremos para você confirmar sua presença.",
            button: "O que mais?",
        },
        18: {
            title: "A aula vai acontecer na nossa plataforma 💻",
            typeInfo: "classroom",
            subtitle:
              "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
            button: "Entendi ✅",
        },
    },
};
